import { itemsFromOrderForm } from './resolvers/items/fromOrderForm';
import { itemsFromItem } from './resolvers/items/fromItem';
import { itemsFromList } from './resolvers/items/fromList';
import { itemsFromPDP } from './resolvers/items/fromPdp';

/**
 * Selects the appropriate item resolver based on the event name and returns its result.
 *
 * @param context - Runtime context passed to the selected resolver
 * @param eventName - Event identifier that determines which resolver to use
 * @returns The resolved items for the event, or `null` if the event is not recognized
 */
export function getItems(context: Record<string, any>, eventName: string) {
  if (context?.items) return context.items;

  switch (eventName) {
    case 'CUSTOM_VIEW_CART':
    case 'BEGIN_CHECKOUT':
    case 'CUSTOM_ADD_SHIPPING_INFO':
    case 'CUSTOM_ADD_PAYMENT_INFO':
    case 'PURCHASE':
      return itemsFromOrderForm(context);
    case 'ADD_TO_CART':
    case 'REMOVE_FROM_CART':
      return itemsFromItem(context);
    case 'SELECT_ITEM':
      return itemsFromList(context)
    case 'VIEW_ITEM':
      return itemsFromPDP(context)
    default:
      return null;
  }
}
